import {List,} from "@mui/material";
import NavItem from "./NavItem";
import useClientQuery from "../../../../global/queries/useClientQuery";
import {ReactComponent as HomeIcon} from "../../../../assets/icons/012 Home.svg";
import {ReactComponent as CompanyIcon} from "../../../../assets/icons/075 Company.svg";
import {ReactComponent as DepartmentIcon} from "../../../../assets/icons/076 Department.svg";
import {ReactComponent as LicenseIcon} from "../../../../assets/icons/125 License.svg";
import {ReactComponent as AdminIcon} from "../../../../assets/icons/109 Admin.svg";



interface IProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const iconList = [
    {text: "Übersicht", icon: HomeIcon, path: "/"},
    {text: "Firmendaten", icon: CompanyIcon, path: "/daten"},
    {text: "Kontakte", icon: DepartmentIcon, path: "/kontakte"},
    {text: "Lizenz-Info", icon: LicenseIcon, path: "/lizenz-info"},
    {text: "Verwaltung", icon: AdminIcon, path: "/verwaltung"},
];

const NavList: React.FC<IProps> = ({open}): JSX.Element => {

    const {data: client} = useClientQuery();

    return (
        <List>
            {[...iconList].map((item, index) => {

                if (item.text === "Verwaltung" && !client?.xuser_roles?.includes("ADMIN")) return "";

                return <NavItem
                    text={item.text}
                    icon={item.icon}
                    index={index}
                    open={open}
                    path={item.path}
                />
            })}
        </List>
    );
};

export default NavList;
